// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"PeripheralReturnList_listContainer__211ci","topBarWrapper":"PeripheralReturnList_topBarWrapper__3wtnZ","inputNumber":"PeripheralReturnList_inputNumber__2QrXR"};